import React from 'react';
import { DateSelect } from '../forms';
import Modal from '../ui/Modal';

interface DateModal {
  closeModal(): void;
  selectedDate: Date;
  setSelectedDate(value: Date): void;
}

const DateModal: React.FC<DateModal> = ({ closeModal, selectedDate, setSelectedDate }) => {
  return (
    <Modal closeModal={closeModal}>
      <h1 className="display f4 fw8 tc">Entry Date</h1>

      <DateSelect selectedDate={selectedDate} setSelectedDate={setSelectedDate} />

      <div className="flex bt b--light-gray navy mt3">
        <button
          className="w-100 f6 pa3 tc blue hover-navy"
          onClick={closeModal}
          data-testid="done-button"
        >
          Done
        </button>
      </div>
    </Modal>
  );
};

export default DateModal;
